import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["icon"];
import React from 'react';
import SVGExternalUse from './SVGExternalUse';
const SVGIcon = _ref => {
  let {
      icon
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  // svg-sprite-loader
  if (typeof icon === 'object') {
    const href = icon.url || `#${icon.id}`;
    return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement(SVGExternalUse, {
      href: href
    }));
  }

  // svg-react-loader
  return /*#__PURE__*/React.createElement(icon, props);
};
export default SVGIcon;